import React, { useEffect } from "react";
import Layout from "../components/layout";
import { useNavigate } from "react-router-dom";

function HomePage() {
  const navigate = useNavigate();
  const getData = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/auth/get-user-info`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
          method: "POST",
        }
      );

      const parseRes = await response.json();
      if (parseRes.success === true) {
        console.log(parseRes.data);
      } else if (parseRes.message === "NOT AUTHORIZED") {
        localStorage.clear();
        navigate("/login");
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <Layout>
      <h1>Home page</h1>
    </Layout>
  );
}

export default HomePage;
